import React from 'react';
import { Icon } from '..';
import colors from '../../utils/colors';
import './style.scss';

function Checkbox({ id, label, checked, onChange }) {
	return (
		<label className="checkbox" id={id}>
			<input type="checkbox" id={id} checked={checked} onChange={onChange} hidden />
			<span className="checkbox-icon">
				<Icon name="check" width="10" height="10" color={colors.white} />
			</span>
			<span className="checkbox-label">{label}</span>
		</label>
	);
}

export default Checkbox;
